import "./wwfconfigs";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import { mapState } from 'vuex';
import store from './store/index';

// Libraries
import firebase from 'firebase/app';
import 'firebase/auth';
import printJS from 'print-js';
import VeeValidate from 'vee-validate'; // Validations library http://vee-validate.logaretm.com/
import vueConfig from 'vue-config';
import VueCookie from 'vue-cookie';
import vueFilter from 'vue-filter';
import VueFormWizard from 'vue-form-wizard';
import resource from 'vue-resource'; // Vue resource library https://github.com/pagekit/vue-resource/blob/develop/docs/http.md
import VueYouTubeEmbed from 'vue-youtube-embed'; // https://github.com/kaorun343/vue-youtube-embed

// Amplitude
import Amplitude from './components/utils/Amplitude.vue';

// Components
import ContactUs from './components/ContactUs.vue';
import LoyaltyForm from './components/LoyaltyForm.vue';
import NewsletterSignup from './components/NewsletterSignup.vue';
import MyPetitionEpbc from './components/PetitionEpbc.vue';
import MyPetitionForm from './components/PetitionForm.vue';
import SocialMedia from './components/SocialMedia.vue';
import ThankYouDonation from './components/ThankYouDonation.vue';
import ThankYouMultiAction from './components/ThankYouMultiAction.vue';
import MyTwitchForm from './components/TwitchForm';
import WwfMenuCountryListBtn from './components/WwfMenuCountryListBtn.vue';
import WwfRichmondFcForm from './components/WwfRichmondFcForm.vue';
import YoutubeVideo from './components/YoutubeVideo.vue';
import RichContentDisplay from './components/utils/RichContentDisplay.vue';

// Forms
import Bequest from './components/forms/Bequest.vue';
import EdoForm from './components/forms/Edo.vue';
import EdoPopup from './components/forms/EdoPopup.vue';
import EdoVideoUpload from './components/forms/EdoVideoUpload.vue';
import GatheredHerePopup from './components/forms/GatheredHerePopup.vue';
import NetFreeNorthForm from './components/forms/NetFreeNorthForm.vue';
import PartnershipsForm from './components/forms/PartnershipsForm.vue';
import Petition from './components/forms/Petition.vue';
import PetitionBio from './components/forms/PetitionBio.vue';
import WeNeedTrees from './components/forms/WeNeedTrees.vue';
import WorkplaceContactUs from './components/forms/WorkplaceContactUs.vue';
import Newsletter from './components/newsletter/Newsletter.vue';

// Earth Hour
import EarthhourCompetition from './components/earth-hour/EarthhourCompetition.vue';
import EarthhourLogoWall from './components/earth-hour/EarthhourLogoWall.vue';
import EarthhourPopup from './components/earth-hour/EarthhourPopup.vue';
import EarthhourRegistration from './components/earth-hour/EarthhourRegistration.vue';

// Components - Search
import SearchAutocomplete from './components/search/SearchAutocomplete.vue';
import SearchResult from './components/search/SearchResult.vue';

// Components - Donation related
import UpdateDetails from './components/donor/UpdateDetails.vue';
import DollarHandleWidget from './components/product/DollarHandleWidget.vue';
import DonateRgForm from './components/product/DonateRgForm.vue';
import DonationTitle from './components/product/DonateTitle.vue';
import DonateWidget from './components/product/DonateWidget.vue';
import DonationListenner from './components/product/DonationListenner.vue';
import FormProduct from './components/product/FormProduct.vue';
import ProductSelector from './components/product/ProductSelector.vue';

// Components - Logos
import LogoWall from './components/LogoWall.vue';

// Components - Threatened Species
import ElectorateDetails from './components/threatened-species/ElectorateDetails.vue';
import ThreatenedSpecies from './components/threatened-species/ThreatenedSpecies.vue';
import ThreatenedSpeciesForm from './components/threatened-species/ThreatenedSpeciesForm.vue';
import ThreatenedSpeciesMap from './components/threatened-species/ThreatenedSpeciesMap.vue';
import ThreatenedSpeciesThankYouPopup from './components/threatened-species/form-components/ThankYouPopup.vue';

// RA
import DonationWidget from './components/DonationWidget.vue';
import StepUp from './components/StepUp.vue';
import Donate from './components/donation/Donate.vue';
import EcommerceCarousel from './components/ecommerce/EcommerceCarousel.vue';
import EcommerceSlider from './components/ecommerce/EcommerceSlider.vue';
import EcommerceFilter from './components/ecommerce/filter/EcommerceFilter.vue';
import RaHubCarousel from './components/hub/RaHubCarousel.vue';
import RaHubSolutions from './components/hub/RaHubSolutions.vue';
import ImpactDonateWrapper from './components/impact-project/ImpactDonateWrapper.vue';
import ImpactProject from './components/impact-project/ImpactProject.vue';
import ImpactProjectHeader from './components/impact-project/ImpactProjectHeader.vue';
import ImpactProjectMilestones from './components/impact-project/ImpactProjectMilestones.vue';
import LeafReliefIntentPopup from "./components/leaf-relief/IntentPopup.vue";
import LeafRelief from './components/leaf-relief/LeafRelief.vue';
import LeafReliefThankYouPopup from './components/leaf-relief/ThankYouPopup.vue';

// Dynamic Petition
import DynamicPetition from './components/dynamic-petition/DynamicPetition.vue';

// CSS
import './styles/alert-message.css';
import './styles/autocomplete.css';
import './styles/donation-carousel.css';
import './styles/donation-form.css';
import './styles/donation.css';
import './styles/earth-hour-popup.css';
import './styles/edo-supporter-messages.css';
import './styles/form.css';
import './styles/global.css';
import './styles/leaf-relief.css';
import './styles/popup-petition-message.css';
import './styles/recaptcha.css';
import './styles/search-bar.css';
import './styles/stepup-popup.css';
import './styles/thankyou-popup.css';
import './styles/threatened-species.css';
import './styles/unknown.css';
import './styles/vdp-datepicker.css';

// Website related CSS
import './styles/carousel.css';

// Helpers
import {
  getNameByDonationType,
  getNameByPaymentType,
  isEditMode,
  resizeIframe,
} from './helpers';

import gtm from "./utils/gtm";

Vue.use(resource);
Vue.use(VueYouTubeEmbed);
Vue.use(VeeValidate, { events: '' });
Vue.use(vueConfig, wwfconfigs);
Vue.use(VueFormWizard); // Vue form wizard register
Vue.use(vueFilter);
Vue.use(VueCookie);

// Add interceptor to add reCAPTCHA
Vue.http.interceptors.push(async (request, next) => {
  const noToken = request.headers.get('no-token') && request.headers.get('no-token') === 'true';
  if (request.method === 'POST' && !noToken) {
    request.headers.set('g-access-token', await store.dispatch('getCaptchaToken'));
  }

  // Remove the flag from the headers
  request.headers.delete('no-token');

  next();
});

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

const firebaseConfig = {
  apiKey: wwfconfigs.FIREBASE_API_KEY,
  projectId: wwfconfigs.FIREBASE_PROJECT_ID,
};
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

const vm = new Vue({
  el: '#bodyapp',
  store: store,
  data() {
    return {
      revealDonation: null,
      revealPetition: null,
      revealPetitionMessage: null,
      revealEarthHour: null,
      revealCustomContent: null,
      revealStepUp: null,
      revealLetter: null,
      isProcessing: false,
      resizeOb: null,
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    product: state => state.product.product,
    update_details: state => state.updates.update_details,
    thankYouPopup: state => state.popup.content,
    openDonationPopup: state => state.popup.openDonationPopup,
    openPetitionPopup: state => state.popup.openPetitionPopup,
    openPetitionMessagePopup: state => state.popup.openPetitionMessagePopup,
    openEarthHourPopup: state => state.popup.openEarthHourPopup,
    openCustomContentPopup: state => state.popup.openCustomContentPopup,
    openStepUpPopup: state => state.popup.openStepUpPopup,
  }),
  created() {
    this.$store.dispatch('login').then(() => {
      this.$store.dispatch('initAmplitude');
    });
  },
  mounted() {
    // Create Resize Observer for iframe resizing
    this.ro = new ResizeObserver((entries) => {
      // console.log();
      // console.log(entries);
      // console.log(JSON.stringify(entries[0]));
      // Only observing body app so first one will be it. 
      // const boxSize = entries[0].devicePixelContentBoxSize[0];
      // console.log(boxSize)
      // const width = boxSize.inlineSize;
      // const height = boxSize.blockSize;

      // console.log("width:", width);
      // console.log("height:", height);
      // console.log("resized");
      resizeIframe();
    });
    const body = document.getElementById("bodyapp");
    this.ro.observe(body);

    // Don't mount the reveal if edit mode
    if (!isEditMode()) {
      this.revealDonation = new Foundation.Reveal($('#reveal-dialog-donation'), { animationIn: 'fade-in-up fast', });
      this.revealPetition = new Foundation.Reveal($('#reveal-dialog-petition'), { animationIn: 'fade-in-up fast', });
      this.revealPetitionMessage = new Foundation.Reveal($('#reveal-popup-petition-message'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-no-scroll' });
      this.revealEarthHour = new Foundation.Reveal($('#reveal-dialog'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-black-background' });
      this.revealCustomContent = new Foundation.Reveal($('#reveal-popup-custom-content'), { animationIn: 'fade-in-up fast' });
      this.revealStepUp = new Foundation.Reveal($('#reveal-popup-stepup'), { animationIn: 'fade-in-up fast' });
    }

    // Amplitude event tracking, site wide
    try {
      // Run when child components have mounted
      this.$nextTick(function () {
        // Skip pages with an amplitude id or donation form, as these already have their own specific amplitude events
        // if (!$('[id^=amplitude-], #donate-form, .dynamic-petition').length) {
        // this.$store.dispatch('logLandingVisit');
        // }

        // Add tracking to WWF & Donate navigation menus
        $('#ra-menu .item, .b-nav .b-nav__item, #MobileNav .b-mobile-nav__item')
          .on('click', 'a', (e) => {
            this.$store.dispatch('logNavClick', {
              topMenuName: $(e.delegateTarget).find('a').first().text(),
              subMenuName: $(e.target).text(),
            });
          });

        // Add tracking to Earth Hour navigation menus
        $('.desktop-navigation ul.hmenu')
          .on('click', 'a', (e) => {
            this.$store.dispatch('logNavClick', {
              topMenuName: $(e.delegateTarget).find('a').first().text(),
              subMenuName: $(e.target).text(),
            });
          });

        // Track Earth Hour Mobile nav
        $('.eh-mobile-navigation .eh-menu ul.hmenu')
          .on('click', 'a', (e) => {
            this.$store.dispatch('logNavClick', {
              topMenuName: $(e.delegateTarget).find('a').first().text(),
              subMenuName: $(e.target).text(),
            });
          });

        // Add tracking to WWF mobile navigation menu
        $('#ra-menu-popup').on('click', 'a', (e) => {
          this.$store.dispatch('logNavClick', {
            topMenuName: $(e.target).text(),
          });
        });

        // Add tracking on navigation search
        $('#wwf-search, .search-mob, #search-autocomplete-input').on('focus', (e) => {
          this.$store.dispatch('logSearchClick');
        });

        $('#wwf-search, .search-mob').on('keydown', (e) => {
          if (e.keyCode == 13) {
            this.$store.dispatch('logSearchEnter', {
              searchValue: $(e.target).val(),
            });
          }
        });

        // Add tracking to all page links
        $('#bodyapp').on('click', 'a', (e) => {
          this.$store.dispatch('logPageLink', e.target.href);
        });

        // Exclude navigation menu from above event delegation
        $('#ra-menu, .ra-menu-mobile, .b-header, #MobileNav').on('click', (e) => {
          e.stopPropagation();
        });

        // Add tracking to all page buttons
        $('#bodyapp').on('click', 'button', (e) => {
          this.$store.dispatch('logPageButton', $(e.target).text().trim());
        });
      })
    } catch (error) {
      console.log(error);
    }
  },
  watch: {
    openDonationPopup: function (val) {
      if (val === true && this.revealDonation) {
        const payload = {
          amount: this.donation.amount,
          donationtype: this.donation.type,
          payementType: this.donation.payementType,
          transactionid: this.donation.transactionid,
          productname: this.product.productname,
          producttype: this.product.producttype,
          productid: this.product.id,
          postcode: this.donation.billing.postcode,
          firstname: this.donation.firstname,
          lastname: this.donation.lastname,
          certificateurl: this.product.certificateurl,
          wildcardurl: (this.donation.wildcard && this.donation.wildcard.pdf) ? this.donation.wildcard.pdf : null,
          showCertificate: this.product.producttype === 'adoption',
          isMonthly: this.donation.type === 'Regular',
          showWildcard: this.product.producttype === 'wildcard'
        };

        // Send data to Google Tag Manager
        gtm.pushPurchase(
          payload.transactionid,
          payload.productname,
          payload.productid,
          payload.producttype,
          getNameByDonationType(payload.donationtype),
          payload.amount,
          payload.postcode,
          getNameByPaymentType(payload.payementType));

        // Set the data to display in the popup
        this.thankYouPopup.firstname = payload.firstname;
        this.thankYouPopup.lastname = payload.lastname;
        this.thankYouPopup.amount = payload.amount;
        this.thankYouPopup.showCertificate = payload.showCertificate;
        this.thankYouPopup.certificateurl = payload.certificateurl;
        this.thankYouPopup.isMonthly = payload.isMonthly;
        this.thankYouPopup.showWildcard = payload.showWildcard;
        this.thankYouPopup.wildcardurl = payload.wildcardurl;

        this.revealDonation.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openDonationPopup', false);
        }, 200);

        if (this.$refs.formproduct && payload.paymenttype != "wwf_paypal") {
          this.$refs.formproduct.reset();
        }
      }
    },
    openPetitionPopup: function (val) {
      if (val === true && this.revealPetition) {
        this.revealPetition.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openPetitionPopup', false);
        }, 200);
      }
    },
    openPetitionMessagePopup: function (val) {
      if (val === true && this.revealPetitionMessage) {
        this.revealPetitionMessage.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openPetitionMessagePopup', false);
        }, 200);
      }
    },
    openEarthHourPopup: function (val) {
      if (val === true && this.revealEarthHour) {
        this.revealEarthHour.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openEarthHourPopup', false);
        }, 200);
      }
    },
    openCustomContentPopup: function (val) {
      if (val === true && this.revealCustomContent) {
        this.revealCustomContent.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openCustomContentPopup', false);
        }, 200);
      }
    },
    openStepUpPopup: function (val) {
      if (val === true && this.revealStepUp) {
        this.revealStepUp.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openStepUpPopup', false);
        }, 200);
      }
    },
  },
  methods: {
    openThankYouPopup: function (e) {
      [this.thankYouPopup.firstname, this.thankYouPopup.lastname, this.thankYouPopup.amount, this.thankYouPopup.showCertificate, this.thankYouPopup.certificateurl, this.thankYouPopup.isMonthly, this.thankYouPopup.showWildcard, this.thankYouPopup.wildcardurl] = e;
      if (this.revealDonation) {
        this.revealDonation.open();
        setTimeout(() => this.thankYouPopup.isOpen = true, 200);
      }
    },
    openThankYouPopupPetition: function (e) {
      [this.thankYouPopup.title, this.thankYouPopup.message, this.thankYouPopup.shareButton, this.thankYouPopup.recommendedReading, this.thankYouPopup.component, this.thankYouPopup.componentparams] = e;
      this.revealPetition.open();
      setTimeout(() => this.thankYouPopup.isOpen = true, 200);
    },
    thankyou: function (amount, donationtype, transactionid, productname, postcode, firstname, lastname, producttype, certificateurl, productid, paymenttype, wildcardurl) {
      gtm.pushPurchase(transactionid, productname, productid, producttype, getNameByDonationType(donationtype), amount, postcode, getNameByPaymentType(paymenttype))
      this.openThankYouPopup([firstname, lastname, amount, producttype == 'adoption', certificateurl, donationtype == 'Regular', producttype == 'wildcard', wildcardurl]);
      if (this.$refs.formproduct && paymenttype != "wwf_paypal") {
        this.$refs.formproduct.reset();
      }
    },
    confirmtransaction: function (transactionid) {
      console.log('confirmtransaction::transactionid', transactionid);
      this.thankyou(this.donation.amount, this.donation.type, transactionid, this.product.productname, this.donation.billing.postcode, this.donation.firstname, this.donation.lastname, this.product.producttype, this.product.certificateurl, this.product.id, this.donation.payementType, (this.donation.wildcard && this.donation.wildcard.pdf) ? this.donation.wildcard.pdf : null)
    },
    confirmtransactionupdatedetail: function (maskedcard, name, date, type) {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.confirmtransaction(maskedcard, name, date, type);
      }
    },
    retryupdatedetail: function retry() {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.retry();
      }
    },
    retry: function () {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.retry();
      }
    },
    disablesteps: function () {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.disablesteps();
      }
    },
    printCertificate: function () {
      printJS({ printable: 'certificate', type: 'html', targetStyles: ['*'] })
    },
    printCertificateNew() {
      console.log('This is a print');
      printJS({ printable: 'thank-you-certificate', type: 'html', targetStyles: ['*'] })
    }
  },
  components: {
    DonateRgForm,
    YoutubeVideo,
    NewsletterSignup,
    MyPetitionForm,
    MyPetitionEpbc,
    MyTwitchForm,
    ContactUs,
    LoyaltyForm,
    WwfRichmondFcForm,
    WwfMenuCountryListBtn,
    PartnershipsForm,
    FormProduct,
    DollarHandleWidget,
    UpdateDetails,
    DonateWidget,
    Bequest,
    SearchAutocomplete,
    SearchResult,
    SocialMedia,
    ThankYouDonation,
    ThankYouMultiAction,
    DonationTitle,
    EarthhourRegistration,
    EarthhourCompetition,
    EdoForm,
    EdoPopup,
    EdoVideoUpload,
    EarthhourLogoWall,
    EarthhourPopup,
    Petition,
    PetitionBio,
    ProductSelector,
    DonationListenner,
    RichContentDisplay,
    Donate,
    LeafRelief,
    LeafReliefThankYouPopup,
    LeafReliefIntentPopup,
    ImpactProject,
    ImpactProjectHeader,
    EcommerceFilter,
    EcommerceCarousel,
    EcommerceSlider,
    ImpactProjectMilestones,
    ImpactDonateWrapper,
    RaHubSolutions,
    RaHubCarousel,
    Newsletter,
    Amplitude,
    StepUp,
    DonationWidget,
    DynamicPetition,
    WorkplaceContactUs,
    GatheredHerePopup,
    LogoWall,
    ThreatenedSpeciesMap,
    ElectorateDetails,
    ThreatenedSpecies,
    ThreatenedSpeciesThankYouPopup,
    ThreatenedSpeciesForm,
    NetFreeNorthForm,
    WeNeedTrees,
  }
});

window.app = vm;



// WEBPACK FOOTER //
// ./src/wwf.main.js